import { useMemo, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Unstable_Grid2';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import QuillEditor from 'src/components/quill-editor';
import { getImg } from 'src/services/AssetApi';
import ZoomImage from 'src/components/zoom-image';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import { validationSchema, handleSubmitted } from './formik';
import StringTextField from 'src/components/widgets/string-textfield';
import NumberTextField from 'src/components/widgets/number-textfield';
import { inputFormatCode, inputFormatQuantity } from 'src/utils/formatters';

export const DetailForm = (props) => {
  const { item, apiUpdateBillNo, apiSendTicket, apiUnsendTicket, ...other } = props;
  const imageSrc = useMemo(() => getImg(item.asset?.name), [item.asset?.name]);

  const [submitState, setSubmitState] = useState({ verified: false, sendSms: false });

  const formik = useCustomFormik({
    initialValues: { referenceField: null, smsField: null },
    validationSchema: validationSchema(),
    
    onSubmit: async (values) => {
      await handleSubmitted(values, item, apiUpdateBillNo, apiSendTicket, apiUnsendTicket);
    },
  });

  useEffect(() => {
    setSubmitState(prev => ({ 
        ...prev,
        sendSms: formik.values.isVerified
      }));
  }, [formik.values.isVerified]);

  useEffect(() => {
    if(item){
      // console.log('==============', item);
      // const isVerified = false; //!!item.ticket
      setSubmitState(prev => ({ 
          ...prev,
          reason: item.ticket?.reason,
          verified: !!item.ticket
        }));
    }
  }, [item]);

  const handleVerify = (isChecked) => {
    let reason = item?.ticket?.reason;
    if(reason){
      reason = isChecked ? reason : 'Hủy thông báo';
    }
    setSubmitState(prev => ({ 
      ...prev,
      reason: reason,
      verified: isChecked
    }));
  };

  return (
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <Grid container spacing={3}>
          <Grid xs={12} md={6}>
            <form onSubmit={formik.handleSubmit} {...other}>
            <Grid container spacing={3}>
              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Số xe" value={item.car?.name} />
              </Grid>

              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Ngày đổ" value={item.paidDate} dateFormat='dd/MM/yyyy' />
              </Grid>

              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Người liên hệ" value={item.contact?.name} />
              </Grid>

              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Số điện thoại" value={item.contact?.phone} enumType="phone" />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Số lượng"
                  name="quantityField"
                  formik={formik}
                  hintValue={item.quantity}
                  inputProps={{ maxLength: 6 }}
                  onChangeValue={(newValue) => {
                    return inputFormatQuantity(newValue);
                  }}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <NumberTextField
                  label="Đơn giá"
                  name="pricingField"
                  formik={formik}
                  hintValue={item.price}
                  inputProps={{ maxLength: 6 }}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Số thẻ"
                  name="cardField"
                  formik={formik}
                  inputProps={{ 
                    maxLength: 4,
                    onInput: (e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, '');
                    },
                  }}
                  hintValue={item.cardNumber}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Thanh toán" value={item.totalPrice}  />
              </Grid>

              <Grid xs={12}>
                {!submitState.sendSms ? (
                  <StringTextField
                    label="Mã tham chiếu"
                    name="referenceField"
                    formik={formik}
                    hintValue={item.referenceCode}
                    inputProps={{ maxLength: 14 }}
                    onChangeValue={(newValue) => {
                      return inputFormatCode(newValue, true);
                    }}
                  />
                ) : (
                  <StringTextField
                    label="Nội dung"
                    name="smsField"
                    formik={formik}
                    hintValue={submitState.reason}
                  />
                )}
              </Grid>
              {/* Web Browser & Mobile */}
              <Grid xs={12}
                  sx={{
                    display: { xs: 'center', md: 'flex' },
                    justifyContent: { xs: 'center', md: 'flex-end' }
                  }}>
                <SubmitButton formik={formik} isRemove={true} labelRemove={'Gửi thông báo'} 
                  hasVerified={submitState.verified} onVerifyChange={handleVerify} />
              </Grid>
    
            </Grid>
            </form>
          </Grid>
          <Grid xs={12} md={6}>
            <><Grid container spacing={3}>
              <Grid xs={12}>
                <QuillEditor
                  value={item.note}
                  isReadOnly={true}
                  sx={{height: 75}}
                />
              </Grid>
              <Grid xs={12}>
                <ZoomImage
                  thumbSrc={imageSrc}
                  zoomSrc={imageSrc}
                  alt={item.id}
                  height="360"
                  frame="auto"
                />
              </Grid>
            </Grid>
            </>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

DetailForm.propTypes = {
  item: PropTypes.object.isRequired,
  apiUpdate: PropTypes.func,
  apiSendMsg: PropTypes.func,
};